import React, { useState, useEffect, useRef } from "react";
import { Input } from "antd";
import PropTypes from "prop-types";

import "./MultiInput.css";

const MultiInput = (props) => {
  MultiInput.propTypes = {
    length: PropTypes.number.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.string,
    dataHandler: PropTypes.func,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    onFull: PropTypes.func,
    className: PropTypes.string,
    checkIsDigit: PropTypes.bool,
  };

  const [innerData, setInnerData] = useState(
    props.data ? props.data : Array(props.length)
  );
  const dataRef = useRef([]);

  const ReplaceAt = (index, replacement) => {
    var changed = false;
    var a = [...innerData];
    if (props.checkIsDigit) {
      a[index] = replacement;
      changed = true;
    } else {
      a[index] = replacement;
      changed = true;
    }
    if (changed && index !== props.length - 1 && replacement !== "") {
      dataRef.current[index + 1].focus();
    } else if (changed && index > 0 && replacement === "") {
      dataRef.current[index - 1].focus();
    }
    return a;
  };

  useEffect(() => {
    if (
      innerData.length === props.maxLength &&
      innerData !== "".repeat(props.maxLength) &&
      !innerData.includes(" ") &&
      !innerData.includes("")
    ) {
      if (props.onFull) {
        props.onFull(innerData.join(""));
      }
    }
    if (props.dataHandler) {
      props.dataHandler(innerData.join(""));
    }
  }, [innerData, props]);

  return (
    <div className={`multi-input ${props.className}`}>
      {[...Array(props.length)].map((value, index) => (
        <div key={index} className="multi-input-segment">
          <Input
            key={index}
            ref={(e) => (dataRef.current[index] = e)}
            className="multi-input-base"
            maxLength={props.maxLength ? props.maxLength : null}
            minLength={props.minLength ? props.minLength : null}
            disabled={props.disabled ? props.disabled : null}
            pattern="[0-9]*"
            inputMode="numeric"
            placeholder={props.placeholder ? props.placeholder[index] : null}
            value={innerData[index] ? innerData[index] : ""}
            onChange={(e) => setInnerData(ReplaceAt(index, e.target.value))}
            bordered={false}
          />
        </div>
      ))}
    </div>
  );
};

export default MultiInput;
